import { Button } from '@accure/ui';
import { CheckCircle, Download, ShieldCheck } from 'lucide-react';

import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/modules/siteview/components/ui/card';

interface CertificationTileProps {
  title: string;
  description?: string;
  status?: string;
  downloadHandler?: () => void;
  isDownloading?: boolean;
  downloadText?: string;
}

export function CertificationTile({
  title,
  description,
  status = 'Certified',
  downloadHandler,
  isDownloading = false,
  downloadText = 'Download Certificate',
}: CertificationTileProps) {
  return (
    <Card className="relative flex h-full flex-col">
      <CardHeader className="grow pb-3">
        <div className="flex items-start justify-between">
          <div className="min-w-0 flex-1">
            <CardTitle className="text-base font-semibold sm:text-lg">
              {title}
            </CardTitle>
            {description && (
              <p className="mt-1 break-words text-xs text-gray-600 sm:text-sm">
                {description}
              </p>
            )}
          </div>
          <ShieldCheck className="ml-2 size-5 shrink-0 text-emerald-500" />
        </div>
      </CardHeader>

      <CardContent className="mt-auto space-y-3">
        <div className="flex items-center">
          <CheckCircle className="mr-2 size-4 text-emerald-500" />
          <span className="text-sm font-medium text-emerald-700">{status}</span>
        </div>
      </CardContent>

      {/* Conditional download button */}
      {downloadHandler && (
        <CardFooter>
          <Button
            variant="outline"
            className="w-full bg-transparent text-xs hover:bg-gray-50"
            onClick={downloadHandler}
            disabled={isDownloading}
          >
            <Download className="mr-2 size-3" />
            {isDownloading ? 'Downloading...' : downloadText}
          </Button>
        </CardFooter>
      )}
    </Card>
  );
}
